<template>
    <div v-if="type === 'flat'" class="step row no-padding">
        <div class="col-md-4">
            <div class="form-group">
                <label for="ownership" class="form-label"><strong>Vlastnictví*</strong></label>
                <select id="ownership" name="ownership" v-model="chosenOwnership">
                    <option v-for="ownership in ownerships" :value="ownership.value">
                        {{ ownership.text }}
                    </option>
                </select>
                <span class="select-arrow">&#9660;</span>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="local_type" class="form-label">Dispozice</label>
                <select id="local_type" name="local_type">
                    <option v-for="localType in localTypes" :value="localType.value">
                        {{ localType.text }}
                    </option>
                </select>
                <span class="select-arrow">&#9660;</span>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label for="construction" class="form-label">Konstrukce</label>
                <select id="construction" name="construction">
                    <option v-for="construction in constructions" :value="construction.value">
                        {{ construction.text }}
                    </option>
                </select>
                <span class="select-arrow">&#9660;</span>
            </div>
        </div>
    </div>
    <div v-else class="step row no-padding">
        <div class="col-md-4 offset-md-4">
            <div class="form-group">
                <label for="construction" class="form-label">Konstrukce</label>
                <select id="construction" name="construction">
                    <option v-for="construction in constructions" :value="construction.value">
                        {{ construction.text }}
                    </option>
                </select>
                <span class="select-arrow">&#9660;</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "More",

        data: function() {
            return {
                ownerships: [
                    { value: null, text: 'Neuvedeno' },
                    { value: 'private', text: 'Osobní' },
                    { value: 'cooperative', text: 'Družstevní' },
                    { value: 'council', text: 'Státní/obecní' },
                    { value: 'other', text: 'Jiné' },
                ],

                localTypes: [
                    { value: null, text: 'Neuvedeno' },
                    { value: '1+kk', text: '1+kk' },
                    { value: '1+1', text: '1+1' },
                    { value: '2+kk', text: '2+kk' },
                    { value: '2+1', text: '2+1' },
                    { value: '3+kk', text: '3+kk' },
                    { value: '3+1', text: '3+1' },
                    { value: '4+kk', text: '4+kk' },
                    { value: '4+1', text: '4+1' },
                    { value: 'jiné', text: 'jiné' },
                ],

                constructions: [
                    { value: null, text: 'Neuvedeno' },
                    { value: 'brick', text: 'Cihlová' },
                    { value: 'wood', text: 'Dřevená' },
                    { value: 'stone', text: 'Kamenná' },
                    { value: 'montage', text: 'Monotovaná' },
                    { value: 'panel', text: 'Panelová' },
                    { value: 'mixed', text: 'Smíšená' },
                    { value: 'low_energy', text: 'Nízkonákladová' },
                    { value: 'other', text: 'Jiná' },
                ],

                chosenOwnership: null,
            }
        },

        computed: {
            type: function () {
                let type = this.$parent.getType();
                if (type == "cottage") {
                    type = "house";
                    this.chosenOwnership = null;
                }

                return type;
            },

            required: function () {
                return this.type != "flat" || this.chosenOwnership != null && this.chosenOwnership.trim() !== '';
            }
        },
    }
</script>

<style scoped>
    .form-group .form-label {
        display: block;
    }

    .form-group select {
        display: block;
        width: 100%;
    }

    .form-group .select-arrow {
        margin-top: 32px;
    }

    .text-center .form-group .form-label {
        text-align: center;
    }

    .text-center .form-group select {
        max-width: 320px;
        margin: 0 auto;
    }

    .form-group select {
        text-align: left !important;
    }
</style>